module.exports = __webpack_public_path__ + "img/logo3.df43027b.png";